module.exports = __webpack_public_path__ + "img/default-blog-img.ae312c0a.svg";